"use strict";

exports.__esModule = true;
exports.default = void 0;

var _KulturnavIcon = _interopRequireDefault(require("../icons/KulturnavIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  icon: _KulturnavIcon.default,
  layout: "finder",
  url: "/kulturnav",
  title: "KulturNav"
};
exports.default = _default;
module.exports = exports.default;